import Grid from '../../../share/grid/Grid.vue'
import Page from '../../../../share/content/Page'
import NewContractorModal from './modal/NewContractor.vue'
import ActionButton from '@/components/bundles/share/grid/ActionButton'

export default {
  template: `
    <div>
        <section class="content">
            <div class="row">
                <div class="col-sm-12">
                    <div class="box box-default box-solid">
                        <div class="box-body table-responsive">
                            <grid :source="gridDataSource"
                                  :name="gridName"
                                  :columns="gridColumns"
                                  :actions="gridActions"
                                  :defaultOrder="[[1, 'asc']]"
                                  @show="actionShow">
                            </grid>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <new-contractor-modal :show="modalNewContractorVisible"
                    @close="modalNewContractorVisible = false"
                    mode="new"
                    :service="service">
        </new-contractor-modal>
    </div>`,
  components: {
    Grid,
    NewContractorModal
  },
  mixins: [
    Page
  ],
  data () {
    return {
      events: {
        addContractor: 'core:contractor:addContractor'
      },
      gridActions: [
        { id: 0, event: 'show', title: 'Szczegóły', icon: 'folder-open', acl: { service: 'core', action: 'get_contractor' } }
      ],
      modalNewContractorVisible: false
    }
  },
  mounted () {
    this.$events.on(this.events.addContractor, this.addContractor)
  },
  computed: {
    gridDataSource () {
      const vm = this
      return { service: vm.service, url: '/contractors' }
    },
    gridColumns() {
      return [
        {
          id: 0,
          data: 'DT_RowId',
          title: '',
          searchable: false,
          orderable: false,
          render: (data, type, row) => {
            return ActionButton.renderActionButtons(data, type, row, this.gridActions, this)
          }
        },
        { id: 1, data: 'symbol', title: 'Symbol' },
        { id: 2, data: 'label', title: 'Nazwa' },
        { id: 3, data: 'phone', title: 'Telefon' },
        { id: 4, data: 'email', title: 'Kontakt' }
      ]
    }
  },
  methods: {
    addContractor () {
      this.modalNewContractorVisible = true
    },
    actionShow (id) {
      const vm = this
      this.$router.push({ name: vm.actionShowUrlName, params: { id } })
    }
  }
}
